import React, { useState } from 'react';

import { Box, Button as ButtonBokeh, ButtonProps } from '@vimeo/bokeh';

type IconType = ButtonProps['leftIcon'];

export type ButtonToggleStateBokehType = {
  isActive?: boolean;
  isIconOnRight?: boolean;
  offIcon?: IconType;
  offStateText: string;
  onIcon?: IconType;
  onStateText: string;
  turnOffActionText: string;
  turnOffIcon?: IconType;
} & Omit<ButtonProps, 'variant'>;

/**
 * Bokeh version of the legacy Iris `ButtonToggleState`
 */
export const ButtonToggleStateBokeh = ({
  isActive,
  isIconOnRight,
  offIcon,
  offStateText,
  onIcon,
  onStateText,
  size,
  turnOffActionText,
  turnOffIcon,
  ...rest
}: ButtonToggleStateBokehType) => {
  const [isHover, setIsHover] = useState<boolean>(false);
  let btnVariant = 'primary';
  let btnContent = offStateText;
  let icon = offIcon;
  if (isActive) {
    btnVariant = isHover ? 'secondary' : 'positive';
    btnContent = isHover ? turnOffActionText : onStateText;
    icon = isHover ? turnOffIcon : onIcon;
  }

  const hoverColors = isActive
    ? {
        color: 'text-primary',
        bgColor: 'background-blur',
        svg: {
          '*': {
            fill: 'text-primary',
          },
        },
      }
    : undefined;

  const { onMouseEnter, onMouseLeave } = rest;
  const handleMouseEnter = (e: React.MouseEvent<HTMLButtonElement>) => {
    onMouseEnter?.(e);
    setIsHover(true);
  };
  const handleMouseLeave = (e: React.MouseEvent<HTMLButtonElement>) => {
    onMouseLeave?.(e);
    setIsHover(false);
  };

  return (
    <ButtonBokeh
      leftIcon={isIconOnRight ? undefined : icon}
      rightIcon={isIconOnRight ? icon : undefined}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      size={size}
      variant={btnVariant}
      _hover={hoverColors}
      {...rest}
    >
      {btnContent}
    </ButtonBokeh>
  );
};
